<template>
  <el-dialog
    title="关闭线索"
    :visible.sync="dialogVisible"
    width="40%"
    class="mergingClueDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="closeClueDialogForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="线索关闭原因" prop="closeReasonText">
            <el-select v-model="formData.closeReasonText" @change="closeReasonChange">
              <el-option v-for="(item, index) in closeReasonList" :key="index" :label="item.fieldValue" :value="item.fieldValue" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="remarkShow">
          <el-form-item label="其他原因" prop="remark">
            <el-input type="textarea" v-model="formData.remark" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { roleManagementApi } from '@/views/backStageManagement/service';
  import { arrayQuery } from '@/utils/utils';
  export default {
    data () {
      return {
        rules: {
          closeReasonText: [
            { required: true, message: '请选择关闭原因', trigger: 'change' }
          ],
          remark: [
            { required: true, message: '请输入其他原因', trigger: 'blur' }
          ]
        },
        dialogVisible: false,
        formData: {},
        closeReasonList: [],
        remarkShow: false
      };
    },
    props: {
      closeClueShow: {
        type: Boolean,
        default: false
      },
      rowData: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    watch: {
      closeClueShow (val) {
        if (val) {
          this.getOptionList();
        } else {
          this.formData = {};
        }
        this.$nextTick(() => {
          this.$refs.closeClueDialogForm.clearValidate();
        });
        this.dialogVisible = val;
      }
    },
    methods: {
      closeReasonChange (val) {
        this.$set(this.formData, 'remark', '');
        if (val.indexOf('其他') >= 0) {
          this.remarkShow = true;
        } else {
          this.remarkShow = false;
        }
      },
      getOptionList () {
        roleManagementApi.getConfigureList('线索关闭原因').then(res => {
          if (res.status === '200') {
            this.closeReasonList = res.data;
          }
        });
      },
      submitHandlen () {
        this.$refs['closeClueDialogForm'].validate((valid) => {
          if (valid) {
            let params = {
              leadId: this.rowData.leadId,
              closeReasonCode: arrayQuery(this.formData.closeReasonText, this.closeReasonList, 'fieldValue').fieldKey
            };
            if (this.formData.remark) {
              params.closeReasonRemark = this.formData.remark;
            } else {
              params.closeReasonRemark = this.formData.closeReasonText;
            }
            this.$emit('closeClueSubHandle', params);
          }
        });
      },
      dialogCloseHandle () {
        this.$emit('dialogCloseHandle');
      }
    }
  };
</script>

<style lang="scss" scoped>
.mergingClueDialog{
  ::v-deep.el-dialog{
    margin-top: 20vh!important;
    .el-dialog__body{
      min-height: 240px;
    }
  }
}
</style>
